import React, { Fragment } from 'react';
import EnquiryForm from '../../common/EnquiryForm.js';

const ContactUs = props => {
    return (
      <Fragment>
        <h1>Contact Us</h1>
        <EnquiryForm />
      </Fragment>
    );
};

export default ContactUs;
